import { render, staticRenderFns } from "./ServicePointHeader.vue?vue&type=template&id=07152a58&scoped=true&"
import script from "./ServicePointHeader.vue?vue&type=script&lang=ts&"
export * from "./ServicePointHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ServicePointHeader.vue?vue&type=style&index=0&id=07152a58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07152a58",
  null
  
)

export default component.exports